import { CONSTANTS } from '@/types/enum/constants'

const getIsPharmacy = (loggedUserRoles: string[]): boolean =>
  !!loggedUserRoles.find(value => [CONSTANTS.ROLE_PHARMACIEN].find(role => role === value)) || false

export default getIsPharmacy
